import { requestWithAuth } from './config';

const resource = '/feedback';

export const getAll = () => {
  return requestWithAuth.get(resource);
};
